import React, { useRef, useState } from "react";
import YuJaButton from "../../components/standardization/YuJaButton";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import useMobileAccess from '../../hooks/useMobileAccess';
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {
    ATTENDANCE, BUTTON, DRAFT_TEXT,
    END_DATE,
    MERGED_MODE, POLL_TEXT,
    POLL_TYPE_HEADER,
    READY_TO_SHARE,
    SCHEDULED,
    SEARCH_BOX_PLACEHOLDER, SEARCH_POLL,
    SEARCH_TEXT,
    SHARED_BY_QUESTION,
    SHARED_ENTIRELY,
    START_DATE,
    STATUS_LABEL,
} from '../../utils/constants';
import { notifyError } from '../../utils/helpers';
import { LOADING_SEARCH_ERROR } from '../../utils/toast-message-constants';
import styles from "./ManagePolls.module.css";
import "./styles.css";
import FilterMenuNew from "../../components/FilterMenuNew";
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";

export default function PollSearchForm({handleSubmit, disabled=false, collapsed=false, isPPT=false, filter={}, setSelectedPoll}) {
    const isNarrow = useRef(useMobileAccess(1200));
    // const windowDimensions = useWindowDimensions();
    const [keyword, setKeyword] = useState(!!filter.keyword ? filter.keyword : "");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [startDate, setStartDate] = useState(!!filter.startDate ? filter.startDate : "");
    const [endDate, setEndDate] = useState(!!filter.endDate ? filter.endDate : "");
    const [modeFilter, setModeFilter] = useState(!!filter.mode ? filter.mode : (isPPT ? [POLL_TEXT] : []));
    const [statusFilter, setStatusFilter] = useState(!!filter.status ? filter.status : []);
    // const [smallScreen, setSmallScreen] = useState(window.innerWidth < 1200);



    const clickSearch = ({key=keyword, start=startDate, end=endDate, mode=modeFilter, status=statusFilter}) => {
        if (disabled) {
            notifyError(LOADING_SEARCH_ERROR);
            return;
        }
        let formattedStartDate = start ? start.split("-").reverse().join("-") : "";
        let formattedEndDate = end ? end.split("-").reverse().join("-") : "";
        handleSubmit({
            keyword: key,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            mode: mode,
            status: status
        });
    };

    const enterKeyup = (e) => {
        if (e.key === 'Enter') {
            clickSearch({});
        }
    }


    const onApply = (filterOptions) => {
        if (isPPT) {
            // setModeFilter(filterOptions.optionFilter1);
            setStatusFilter(filterOptions.optionFilter1);
            setStartDate(filterOptions.dateFilter1);
            setEndDate(filterOptions.dateFilter2);
            clickSearch({
                start: filterOptions.dateFilter1,
                end: filterOptions.dateFilter2,
                mode: modeFilter,
                status: filterOptions.optionFilter1
            });
        } else {
            setModeFilter(filterOptions.optionFilter1);
            setStatusFilter(filterOptions.optionFilter2);
            setStartDate(filterOptions.dateFilter1);
            setEndDate(filterOptions.dateFilter2);
            clickSearch({
                start: filterOptions.dateFilter1,
                end: filterOptions.dateFilter2,
                mode: filterOptions.optionFilter1,
                status: filterOptions.optionFilter2
            });
        }

    };

    return (
        <div style={{width: "100%", display: "flex", alignItems: "center"}}>

            {isPPT &&
                <>
                    <div className={classes.cardTabContainer}>
                        <span
                            tabIndex={0}
                            role={BUTTON}
                            onClick={() => {
                                if (!modeFilter.includes(POLL_TEXT)) {
                                    setSelectedPoll({});
                                }

                                setModeFilter([POLL_TEXT]);
                                clickSearch({
                                    start: startDate,
                                    end: endDate,
                                    mode: [POLL_TEXT],
                                    status: statusFilter
                                });
                            }}
                            className={`${classes.cardTab} ${modeFilter.includes(POLL_TEXT) ? classes.active : ""}`}
                        >
                            {POLL_TEXT}
                        </span>
                        <span
                            tabIndex={0}
                            role={BUTTON}
                            onClick={() => {
                                if (!modeFilter.includes(ATTENDANCE)) {
                                    setSelectedPoll({});
                                }
                                setModeFilter([ATTENDANCE]);
                                clickSearch({
                                    start: startDate,
                                    end: endDate,
                                    mode: [ATTENDANCE],
                                    status: statusFilter
                                });
                            }}
                            className={`${classes.cardTab} ${modeFilter.includes(ATTENDANCE) ? classes.active : ""}`}
                        >
                            {ATTENDANCE}
                        </span>
                    </div>
                    <div style={{width: 70, flexShrink: 1}}/>
                </>
            }

            <div className={styles.searchBox} style={{zIndex: 2}}>
                <FilterMenuNew
                    show={showFilterMenu}
                    setShow={setShowFilterMenu}
                    onApply={onApply}
                    filterOptions={
                    isPPT
                        ? {
                            // optionFilter1Name: POLL_TYPE_HEADER,
                            // optionFilter1: modeFilter,
                            // optionsFilter1: [MERGED_MODE, ATTENDANCE],
                            optionFilter1Name: STATUS_LABEL,
                            optionFilter1: statusFilter,
                            optionsFilter1: modeFilter.includes(POLL_TEXT)
                                ? [DRAFT_TEXT, READY_TO_SHARE, SHARED_BY_QUESTION, SHARED_ENTIRELY]
                                : [READY_TO_SHARE, SHARED_ENTIRELY],
                            dateFilter1Name: START_DATE,
                            dateFilter1: startDate,
                            dateFilter2Name: END_DATE,
                            dateFilter2: endDate
                        }
                        : {
                            optionFilter1Name: POLL_TYPE_HEADER,
                            optionFilter1: modeFilter,
                            optionsFilter1: [MERGED_MODE, ATTENDANCE],
                            optionFilter2Name: STATUS_LABEL,
                            optionFilter2: statusFilter,
                            optionsFilter2: [DRAFT_TEXT, READY_TO_SHARE, SHARED_BY_QUESTION, SHARED_ENTIRELY, SCHEDULED],
                            dateFilter1Name: START_DATE,
                            dateFilter1: startDate,
                            dateFilter2Name: END_DATE,
                            dateFilter2: endDate
                        }
                    }
                    isPPT={isPPT}
                />

                <YuJaTextBox
                    label={SEARCH_POLL}
                    containerStyle={{fontSize: 14, lineHeight: 1.6, flex: 1, height: 40}}
                    placeholder={SEARCH_BOX_PLACEHOLDER}
                    onChange={e => setKeyword(e.target.value)}
                    onKeyUp={enterKeyup}
                    value={keyword}
                    before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                />

                <YuJaButton onClick={clickSearch} style={{height: 40, width: 80, fontSize: 14, lineHeight: 1.6,}}>{SEARCH_TEXT}</YuJaButton>
            </div>
        </div>
    );
}